import React from 'react';

import { StepConnectorIcon } from 'ui/icons';

import { StepConnectorProps } from './StepConnector.types';
import { useStyles } from './StepConnector.styles';

export const StepConnector = ({ numberOfSteps, currentIndex, activeStep }: StepConnectorProps) => {
  const classes = useStyles({ numberOfSteps, currentIndex, activeStep });

  return (
    <div className={classes.container}>
      <StepConnectorIcon className={classes.svg} />
    </div>
  );
};
